"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timestamp = void 0;
const zod_1 = require("zod");
/**
 * Represents a Unix timestamp in since the epoch (1970-01-01T00:00:00Z). The specific time granularity (seconds, milliseconds, etc.) should be
 * determined by the context in which this type is used.
 */
exports.Timestamp = zod_1.z.number().int().positive();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGltZXN0YW1wLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2VudGl0aWVzL3RpbWVzdGFtcC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBdUI7QUFFdkI7OztHQUdHO0FBQ1UsUUFBQSxTQUFTLEdBQUcsT0FBQyxDQUFDLE1BQU0sRUFBRSxDQUFDLEdBQUcsRUFBRSxDQUFDLFFBQVEsRUFBRSxDQUFBIn0=